import React from 'react';
import { IconBox } from 'components';
import {
  Row,
  Col,
  ButtonGroup,
  Button,
  FormGroup,
  FormControl,
  ControlLabel
} from 'react-bootstrap';

class PlanSelectorBox extends React.Component {
  constructor(props) {
    super(props);

    this.handleClickInput = this.handleClickInput.bind(this);
    this.intervalSelector = this.intervalSelector.bind(this);
  }

  handleClickInput() {
    if(this.props.quantity_input_disabled) {
      $('.plan-selector-interval-buttons').animateBounce();
    }
  }
  intervalSelector() {
    return (
      <div>
        <div className='plan-selector-interval-buttons'>
          <Row>
            <Col md={8} xs={8} mdOffset={2} xsOffset={2}>
              <ButtonGroup justified>
                <Button
                  onClick={this.props.onMonthClick}
                  active={this.props.month_selected}
                  >
                  Monthly
                </Button>
                <Button
                  onClick={this.props.onYearClick}
                  active={this.props.year_selected}
                  >
                  Yearly
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Row>
            <Col md={4} xs={4} mdOffset={2} xsOffset={2}>
              <p>{`$${(+(this.props.prices.month) / 100).toFixed(2)} / month`}</p>
            </Col>
            <Col md={4} xs={4}>
              <p>{`$${(+(this.props.prices.year) / 100).toFixed(2)} / year`}</p>
            </Col>
          </Row>
        </div>
        <Row>
          <Col md={8} xs={8} mdOffset={2} xsOffset={2}>
            <FormGroup>
              <ControlLabel>Enter Quantity</ControlLabel>
              <div onClick={this.handleClickInput}>
                <FormControl
                  onChange={this.props.handleQuantityChange}
                  disabled={this.props.quantity_input_disabled}
                  value={this.props.quantity_value || ''}
                  type='number'
                  min={0}
                />
              </div>
            </FormGroup>
          </Col>
        </Row>
      </div>
    );
  }
  render() {
    return (
      <IconBox
        {...this.props}
        CustomComponent={this.intervalSelector()}
      />
    )
  }
}

export default PlanSelectorBox;



// WEBPACK FOOTER //
// ./src/browser/components/settings/subscriptions/plans_calculator/partials/PlanSelectorBox.js